import React from 'react';
import Maps from './Maps';
import { GiRotaryPhone } from 'react-icons/gi'
import { FcCalendar,FcCellPhone } from 'react-icons/fc'
import { MdFacebook } from 'react-icons/md'
const Contacto = () =>{


      return(
          <div>

            <div className='row' style={{paddingTop:50,margin:0}}>
                <div className='col-12 col-md-6' style={{paddingLeft:40}}>
                    <h2 style={{borderLeft:"solid",borderWidth:10,borderColor:"#C4C4C4"}}><b>&nbsp; Contactanos!</b></h2>
                    <p>Para mayores informes acudir a nuestras instalaciones en:</p>
                    <span>Dom. Conocido Col. Santa Catarina,</span><br/>
                    <span><GiRotaryPhone/>  9656909335</span><br/>
                    <span><FcCellPhone/>  9651199669</span><br/>
                    <span><a href='https://es-la.facebook.com/Plantel158/'><MdFacebook/> Cetis 158</a></span><br/><br/>

                    <p><b>Horario de atencion: <FcCalendar/></b></p>
                    <p>Lunes - Viernes</p>
                    <p>De 8:00 a 13:00 Horas Y de 14:00 a 20:00 Horas </p>
                    

                </div>
                <div className='col-12 col-md-5' style={{height:400}}>
                    <div className='column'>
                        <h2 style={{borderLeft:"solid",borderWidth:10,borderColor:"#C4C4C4"}}><b>&nbsp; Ubícanos</b></h2>                            
                    </div>
                    <Maps></Maps>
                </div>
            </div>
            
          </div>
      )

}

export default Contacto;